module.exports = __webpack_public_path__ + "static/media/676.7f879fe9.png";